<template>
  <div>
    <Head title="Asterisk dashboard" />
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="flex w-full items-center justify-center mb-6">
        <div class="w-1/2">
          <div class="mb-6 text-3xl font-bold text-center">Кузляр</div>
          <div class=" flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">Получено звонков</div>
            <div class="w-1/2">Пропущено звонков</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.kyzler.offered_calls }}</div>
            <div class="w-1/2">{{ stats.kyzler.abandoned_calls }}</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
            <Line v-if="loaded" :data="chartData" :options="chartOptions" />
          </div>
          <div class="flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">Свободных операторов</div>
            <div class="w-1/2">Звонков в очереди</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.kyzler.available_operators }}</div>
            <div class="w-1/2">{{ stats.kyzler.queued_calls }}</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
  <!--          <Bar v-if="loaded" :data="chartData" :options="chartOptions" />-->
          </div>
          <div class="flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">SL</div>
            <div class="w-1/2">Время звонка</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.kyzler.sl }}</div>
            <div class="w-1/2">{{ stats.kyzler.average_time }} сек.</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
  <!--          <Bar v-if="loaded" :data="chartData" :options="chartOptions" />-->
          </div>
        </div>
        <div class="w-1/2">
          <div class="mb-6 text-3xl font-bold text-center">Третий глаз</div>
          <div class=" flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">Получено звонков</div>
            <div class="w-1/2">Пропущено звонков</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.glaz.offered_calls }}</div>
            <div class="w-1/2">{{ stats.glaz.abandoned_calls }}</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
            <Line v-if="loaded" :data="chartData2" :options="chartOptions" />
          </div>
          <div class="flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">Свободных операторов</div>
            <div class="w-1/2">Звонков в очереди</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.glaz.available_operators }}</div>
            <div class="w-1/2">{{ stats.glaz.queued_calls }}</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
            <!--          <Bar v-if="loaded" :data="chartData" :options="chartOptions" />-->
          </div>
          <div class="flex w-full items-center justify-between mb-1 text-2xl font-bold text-center">
            <div class="w-1/2">SL</div>
            <div class="w-1/2">Время звонка</div>
          </div>
          <div class=" flex w-full items-center justify-between mb-6 text-2xl font-bold text-center">
            <div class="w-1/2">{{ stats.glaz.sl }}</div>
            <div class="w-1/2">{{ stats.glaz.average_time }} сек.</div>
          </div>
          <div style="position: relative; height: 20vh" class="px-2">
            <!--          <Bar v-if="loaded" :data="chartData" :options="chartOptions" />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout2'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from "@/Shared/TextInput.vue";
import FileInput from "@/Shared/FileInput.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";
import { Bar, Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Point,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
} from 'chart.js'
import axios from "axios";

ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, PointElement, CategoryScale, LinearScale)

export default {
  components: {
    LoadingButton,
    FileInput,
    TextInput,
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Bar,
    Line,
  },
  computed: {

  },
  layout: Layout,
  props: {
    filters: Object,
    //chartData: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      loaded: false,
      stats: {
        kyzler: {
          offered_calls: 0,
          answered_calls: 0,
          abandoned_calls: 0,
          queued_calls: 0,
          available_operators: 0,
          sl: 0,
          average_time: 0,
        },
        glaz: {
          offered_calls: 0,
          answered_calls: 0,
          abandoned_calls: 0,
          queued_calls: 0,
          available_operators: 0,
          sl: 0,
          average_time: 0,
        }
      },
      chartData: {
        labels: [],
        datasets: [{
          label: 'Полученные звонки',
          data: [],
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1
        }, {
            label: 'Потерянные звонки',
            data: [],
            fill: false,
            borderColor: '#f87979',
            tension: 0.1
          }
        ]
      },
      chartData2: {
        labels: [],
        datasets: [{
          label: 'Полученные звонки',
          data: [],
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1
        }, {
          label: 'Потерянные звонки',
          data: [],
          fill: false,
          borderColor: '#f87979',
          tension: 0.1
        }
        ]
      },
      chartOptions: {
        animation: false,
        maintainAspectRatio: false,
        aspectRatio: 5,
        plugins: {
          subtitle: {
            display: true,
            text: 'Custom Chart Subtitle'
          }
        }
      }
    }
  },
  async mounted () {
    this.loaded = false
    setTimeout( () =>  {
      this.reload();
    }, 5000)
    try {

      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

    reload() {
      axios
          .get("/asterisk/dashboard/stats")
          .then((response) => {
            console.log(response.data);
            this.chartData = response.data.chartData;
            this.chartData2 = response.data.chartData2;
            this.stats = response.data.stats;
            setTimeout( () =>  {
              this.reload();
            }, 5000)
          })
    }
  },
}
</script>
